import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/98798803992166c7c4dc4e40a4a437f2.jpg"
          alt="Technology for Better Living"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-20 py-32">
        <div className="max-w-5xl mx-auto text-center text-white">
          {/* Concept Copy */}
          <p className="text-base md:text-lg mb-8 text-white/90 font-light tracking-wide">
            新しいテクノロジーで、アジアと地方の暮らしをもっと楽に、もっと豊かに。
          </p>

          {/* English Heading */}
          <h2 className="text-lg md:text-xl tracking-widest font-light uppercase mb-4 text-blue-100">
            Technology for Better Living
          </h2>

          {/* Main Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-8">
            アジアと地域をつなぐ、<br />暮らしのインフラづくり。
          </h1>

          {/* Lead Text */}
          <p className="text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-12 text-white/95">
            アジアの成長と日本の技術力を融合させ、地域社会に根ざした新しい価値を創造します。
            デジタル決済、食品流通、ヘルスケア、インフラ技術の4つの事業を通じて、
            持続可能な未来を実現します。
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/business"
              className="inline-flex items-center justify-center whitespace-nowrap px-10 py-4 bg-blue-900 text-white rounded-lg font-medium hover:bg-blue-800 hover:shadow-lg transition-all duration-300 cursor-pointer"
            >
              事業内容を見る
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center whitespace-nowrap px-10 py-4 bg-white text-blue-900 rounded-lg font-medium hover:shadow-lg transition-all duration-300 cursor-pointer"
            >
              お問い合わせ
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
